import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import UserGeneralTopbar from './UserGeneralTopbar';
import keyPayEmployeeService from '../../../../services/KeypayEmployee';
import { getFormattedEmployeeFromSelectedObj } from '../../helper/helper';
import UserPortalAccessDialog from '../../dialog/UserPortalAccessDialog';

import ReactSelect from 'react-select';

import Grid from '@mui/material/Grid';
import { withStyles, makeStyles, useTheme } from '@material-ui/core/styles';
import InputBase from '@material-ui/core/InputBase';
import InputLabel from '@material-ui/core/InputLabel';
import { Checkbox, CircularProgress, Paper, Switch, Typography, useMediaQuery } from '@material-ui/core';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import PermContactCalendarIcon from '@material-ui/icons/PermContactCalendar';
import AccountBalanceIcon from '@material-ui/icons/AccountBalance';
import VerifiedUserIcon from '@material-ui/icons/VerifiedUser';
import { toast } from 'react-hot-toast';
import FlightTakeoffIcon from '@material-ui/icons/FlightTakeoff';
import BusinessIcon from '@material-ui/icons/Business';
import UserOfficeInfo from './UserOfficeInfo';
import employeeService from '../../../../services/EmployeeService';
import { Controller } from 'react-hook-form';
import FormHelperText from '@mui/material/FormHelperText';

const BootstrapInput = withStyles((theme) => ({
  root: {
    'label + &': {
      //   marginTop: theme.spacing(1)
    }
  },
  input: {
    borderRadius: 4,
    position: 'relative',
    backgroundColor: theme.palette.common.white,
    border: '2px solid #ced4da',
    fontSize: 16,
    width: '100%',
    padding: '10px 12px',

    transition: theme.transitions.create(['border-color', 'box-shadow']),
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"'
    ].join(','),
    '&:focus': {
      // boxShadow: `${alpha(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
      borderColor: theme.palette.primary.main
    }
  }
}))(InputBase);

const useStyles = makeStyles((theme) => ({
  inputLabel: {
    color: 'rgb(107, 108, 114)',
    fontSize: '1rem'
  },
  bootstrapInput: {
    maxWidth: '350px',
    width: ' 100%'
  },
  paper: {
    padding: theme.spacing(3)
  },
  iconHeader: {
    display: 'flex'
  },
  portalAccessPanel: {
    border: '1px solid #e0e0e0',
    borderRadius: 4,
    padding: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1)
  },
  portalAccessPanelDisabled: {
    backgroundColor: '#f7f7f7',
    color: '#777'
  },
  inlineControl: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1)
  }
}));

const UserGeneralDialogContent = ({
  row,
  onChange,
  vendorRecords,
  keyPayEmployeeRecords,
  selectedEmployeeToRegister,
  setSelectedEmployeeToRegister,
  selectedUserType,
  setSelectedUserType,
  approvalRequired,
  setApprovalRequired,
  selectedApprover,
  setSelectedApprover,
  open,
  portalAccess,
  setPortalAccess,
  portalAccessDialog,
  setPortalAccessDialog,
  setRows,
  rows,
  control,
  errors,
  setFormValue,
  outlookEmailStatus
}) => {
  const classes = useStyles();
  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down('sm'));

  const [annualLeave, setAnnualLeave] = useState(0);
  const [rdo, setRdo] = useState(0);
  const [personalLeave, setPersonalLeave] = useState(0);
  const [portalAccessSubmitting, setPortalAccessSubmitting] = useState(false);

  const hasExistingUser = Boolean(row?.id);
  const portalAccessChecked = Boolean(portalAccess);

  useEffect(() => {
    if (open && row.KeyPayEmployeeId) {
      const fetchKeyPayEmployee = async () => {
        try {
          const keyPayEmployee = await keyPayEmployeeService.getOneKeyPayEmployee(row.KeyPayEmployeeId);

          const formattedEmployee = getFormattedEmployeeFromSelectedObj(keyPayEmployee.data.data);

          setSelectedEmployeeToRegister(formattedEmployee);
        } catch (error) {
          // eslint-disable-next-line no-console, no-undef
          console.log('error is:', error);
        }
      };
      fetchKeyPayEmployee();
    }
  }, [row.KeyPayEmployeeId, setSelectedEmployeeToRegister, open]);

  //get employee leave balance from KeyPay
  useEffect(() => {
    if (open && row.KeyPayEmployeeId) {
      const fetchEmployeeLeaveBalance = async () => {
        try {
          const keyPayEmployeeLeaveBalance = await keyPayEmployeeService.getEmployeeLeaveBalance(row.KeyPayEmployeeId);

          const employeeLeaveBalanceData = await keyPayEmployeeLeaveBalance.data.data;
          employeeLeaveBalanceData.map((leaveItem) => {
            if (leaveItem.leaveCategoryId === 55346) {
              setAnnualLeave(leaveItem.accruedAmount);
            }
            if (leaveItem.leaveCategoryId === 403364) {
              setRdo(leaveItem.accruedAmount);
            }
            if (leaveItem.leaveCategoryId === 55347) {
              setPersonalLeave(leaveItem.accruedAmount);
            }
          });

          // setSelectedEmployeeToRegister(formattedEmployee);
        } catch (error) {
          // eslint-disable-next-line no-console, no-undef
          console.log('error is:', error);
        }
      };
      fetchEmployeeLeaveBalance();
    }
  }, [row.KeyPayEmployeeId, open]);

  const userListOptions = rows?.map((row) => {
    return { value: row.DisplayName, label: row.DisplayName, id: row.id };
  });

  const userTypeOptions = [
    { value: 'User', label: 'User' },
    { value: 'Admin', label: 'Admin' }
  ];

  const handlePortalAccessDialog = () => {
    if (!hasExistingUser || portalAccessSubmitting) return;
    setPortalAccessDialog(true);
  };

  const handlePortalAccessDialogClose = () => {
    setPortalAccessDialog(false);
  };

  const sendLoginDetailsToUser = () => {
    if (!hasExistingUser) {
      toast.error('Save the user before giving portal access.');
      setPortalAccessDialog(false);
      return;
    }

    const employeePayload = {
      employeeId: row.id,
      email: row.email
    };

    setPortalAccessSubmitting(true);

    employeeService
      .sendLoginDetailsToUser(employeePayload)
      .then((response) => {
        const updatedRow = rows.map((r) => {
          if (r.id === row.id) {
            return { ...r, portalAccess: true };
          }
          return r;
        });

        setRows(updatedRow);
        setPortalAccess(true);

        toast.success(response?.data?.message || 'Successfully sent login details to the user');
      })
      .catch((error) => {
        toast.error(error?.response?.data?.message || error?.message || "Couldn't send user credentials.");
      })
      .finally(() => {
        setPortalAccessSubmitting(false);
        setPortalAccessDialog(false);
      });
  };

  // console.log('row in user edit section', row, row.portalAccess);

  const removeLoginDetailsOfUser = () => {
    if (!hasExistingUser) {
      setPortalAccessDialog(false);
      return;
    }

    const employeePayload = {
      employeeId: row.id,
      email: row?.email
    };

    setPortalAccessSubmitting(true);

    employeeService
      .removeLoginDetailsOfUser(employeePayload)
      .then((response) => {
        const message = response?.data?.message || 'User removal process completed.';
        toast.success(message);

        const updatedRow = rows.map((r) => {
          if (r.id === row.id) {
            return { ...r, portalAccess: false };
          }
          return r;
        });
        setRows(updatedRow);
        setPortalAccess(false);
      })
      .catch((error) => {
        toast.error(error?.response?.data?.message || error?.message || 'Could not remove user portal access.');
      })
      .finally(() => {
        setPortalAccessSubmitting(false);
        setPortalAccessDialog(false);
      });
  };

  const handleApprovalRequired = (e) => {
    setApprovalRequired(e.target.checked);
    setSelectedApprover();
    setFormValue('approvalRequired', e.target.checked, { shouldDirty: true, shouldValidate: true });
    setFormValue('approverId', '', { shouldDirty: true, shouldValidate: true });
  };

  //to set approver of targeted/edited user
  const handleSelectedApprover = (selectedApprover) => {
    setSelectedApprover(selectedApprover);
    setFormValue('approverId', selectedApprover?.id || '', { shouldDirty: true, shouldValidate: true });
  };

  //to set user type
  const handleSelectedUserType = (selectedUserType) => {
    setSelectedUserType(selectedUserType);
    setFormValue('userRole', selectedUserType?.value || '', { shouldDirty: true, shouldValidate: true });
  };

  const renderInput = (name, extraProps = {}) => (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <>
          <BootstrapInput
            {...extraProps}
            {...field}
            value={field.value ?? ''}
            onChange={(event) => {
              field.onChange(event);
              onChange(event);
            }}
            id={`user-${name}`}
            className={classes.bootstrapInput}
          />
          {errors?.[name] && <FormHelperText error>{errors[name].message}</FormHelperText>}
        </>
      )}
    />
  );

  return (
    <div>
      {!row.id && (
        <UserGeneralTopbar
          vendorRecords={vendorRecords}
          keyPayEmployeeRecords={keyPayEmployeeRecords}
          setSelectedEmployeeToRegister={setSelectedEmployeeToRegister}
        />
      )}

      <Grid container spacing={3}>
        {/* name and contacts item container */}
        <Grid item container xs={12} mt={3}>
          <Paper className={classes.paper}>
            {/* header */}
            <Grid item xs={12} className={classes.iconHeader}>
              <PermContactCalendarIcon style={{ marginRight: '4px' }} />
              <Typography fontSize={16}>Name and contact</Typography>
            </Grid>

            <Grid item container xs={12} spacing={2} pl={isSmall ? 0 : 3}>
              {/* title  */}
              <Grid item xs={12} sm={2} marginTop={2}>
                <InputLabel shrink htmlFor="bootstrap" className={classes.inputLabel}>
                  Title
                </InputLabel>
                {renderInput('Title')}
              </Grid>

              {/* first name */}
              <Grid item xs={12} sm={4} marginTop={isSmall ? 0 : 2}>
                <InputLabel shrink htmlFor="bootstrap" className={classes.inputLabel}>
                  First Name
                </InputLabel>
                {renderInput('FirstName')}
              </Grid>

              {/* middle name */}
              <Grid item xs={12} sm={3} marginTop={isSmall ? 0 : 2}>
                <InputLabel shrink htmlFor="bootstrap" className={classes.inputLabel}>
                  Middle Name
                </InputLabel>
                {renderInput('MiddleName')}
              </Grid>

              {/* last name */}
              <Grid item xs={12} sm={3} marginTop={isSmall ? 0 : 2}>
                <InputLabel shrink htmlFor="bootstrap" className={classes.inputLabel}>
                  Last Name
                </InputLabel>
                {renderInput('FamilyName')}
              </Grid>

              {/* email */}
              <Grid item xs={12} sm={4}>
                <InputLabel shrink htmlFor="bootstrap" className={classes.inputLabel}>
                  Email
                </InputLabel>
                {renderInput('email', { type: 'email' })}
              </Grid>

              {/* work email */}
              <Grid item xs={12} sm={4}>
                <InputLabel shrink htmlFor="bootstrap" className={classes.inputLabel}>
                  Work Email
                </InputLabel>
                {renderInput('workEmail', { type: 'email' })}
                {outlookEmailStatus === 'checking' && <FormHelperText>Checking Microsoft Outlook…</FormHelperText>}
                {outlookEmailStatus === 'valid' && (
                  <FormHelperText style={{ color: '#2e7d32' }}>Microsoft Outlook user verified.</FormHelperText>
                )}
              </Grid>

              {/* phone */}
              <Grid item xs={12} sm={4}>
                <InputLabel shrink htmlFor="bootstrap" className={classes.inputLabel}>
                  Phone
                </InputLabel>
                {renderInput('PrimaryPhone', { required: true, inputProps: { inputMode: 'tel', maxLength: 14 } })}
              </Grid>

              {/* keypay id as external id */}
              <Grid item xs={12} sm={4}>
                <InputLabel shrink htmlFor="bootstrap" className={classes.inputLabel}>
                  External Id
                </InputLabel>
                <BootstrapInput
                  name="keyPayId"
                  value={row.KeyPayEmployeeId || selectedEmployeeToRegister?.KeyPayEmployeeId || ''}
                  onChange={onChange}
                  id="bootstrap"
                  className={classes.bootstrapInput}
                  disabled
                />
              </Grid>

              {/*Job Title from keypay*/}
              <Grid item xs={12} sm={4}>
                <InputLabel shrink htmlFor="bootstrap" className={classes.inputLabel}>
                  Job Title
                </InputLabel>
                {renderInput('jobTitle')}
              </Grid>

              {/* hourly rate */}
              <Grid item xs={12} sm={4}>
                <InputLabel shrink htmlFor="bootstrap" className={classes.inputLabel}>
                  Hourly Rate
                </InputLabel>
                {renderInput('keyPayEmployeeHourlyRate', { type: 'number' })}
              </Grid>

              {/* Date of birth */}
              <Grid item xs={12} sm={4}>
                <InputLabel shrink htmlFor="bootstrap" className={classes.inputLabel}>
                  Date of Birth
                </InputLabel>
                {renderInput('DateOfBirth', { type: 'date' })}
              </Grid>

              {/*Anniversary date */}
              <Grid item xs={12} sm={4}>
                <InputLabel shrink htmlFor="bootstrap" className={classes.inputLabel}>
                  Anniversary Date
                </InputLabel>
                {renderInput('AnniversaryDate', { type: 'date' })}
              </Grid>
            </Grid>
          </Paper>
        </Grid>

        {/* bank information container */}
        <Grid item xs={12}>
          <Paper className={classes.paper}>
            {/* header */}
            <Grid item xs={12} className={classes.iconHeader}>
              <AccountBalanceIcon style={{ marginRight: '4px' }} />
              <Typography fontSize={16}>Bank Information</Typography>
            </Grid>

            <Grid item container xs={12} mt={1} spacing={2} pl={isSmall ? 0 : 3}>
              <Grid item xs={12} sm={4}>
                <InputLabel shrink htmlFor="bootstrap" className={classes.inputLabel}>
                  Name
                </InputLabel>
                {renderInput('bankAccount1_AccountName')}
              </Grid>

              <Grid item xs={12} sm={4}>
                <InputLabel shrink htmlFor="bootstrap" className={classes.inputLabel}>
                  BSB
                </InputLabel>
                {renderInput('bankAccount1_BSB')}
              </Grid>

              <Grid item xs={12} sm={4}>
                <InputLabel shrink htmlFor="bootstrap" className={classes.inputLabel}>
                  Number
                </InputLabel>
                {renderInput('bankAccount1_AccountNumber')}
              </Grid>
            </Grid>
          </Paper>
        </Grid>

        {/* Superfund information container */}
        <Grid item xs={12}>
          <Paper className={classes.paper}>
            <Grid item xs={12} className={classes.iconHeader}>
              <AccountBalanceIcon style={{ marginRight: '4px' }} />
              <Typography fontSize={16}>SuperFund Information</Typography>
            </Grid>

            <Grid item container xs={12} mt={1} spacing={2} pl={isSmall ? 0 : 3}>
              <Grid item xs={12} sm={4}>
                <InputLabel shrink htmlFor="bootstrap" className={classes.inputLabel}>
                  Name
                </InputLabel>
                {renderInput('superFund1_FundName')}
              </Grid>

              <Grid item xs={12} sm={4}>
                <InputLabel shrink htmlFor="bootstrap" className={classes.inputLabel}>
                  Code
                </InputLabel>
                {renderInput('superFund1_ProductCode')}
              </Grid>

              <Grid item xs={12} sm={4}>
                <InputLabel shrink htmlFor="bootstrap" className={classes.inputLabel}>
                  Number
                </InputLabel>
                {renderInput('superFund1_MemberNumber')}
              </Grid>
            </Grid>
          </Paper>
        </Grid>

        {/* address item container */}
        <Grid item container xs={12}>
          <Paper className={classes.paper}>
            <Grid item xs={12} className={classes.iconHeader}>
              <LocationOnIcon style={{ marginRight: '4px' }} />
              <Typography fontSize={16}>Address</Typography>
            </Grid>

            <Grid item container xs={12} mt={1} spacing={2} pl={isSmall ? 0 : 3}>
              <Grid item xs={12}>
                <p
                  style={{
                    padding: '0',
                    margin: '0',
                    fontSize: '14px',
                    fontWeight: '400',
                    color: '#393A3D',
                    lineHeight: '0.1'
                  }}
                >
                  Billing address
                </p>
              </Grid>

              <Grid item xs={12} sm={4}>
                <InputLabel shrink htmlFor="bootstrap" className={classes.inputLabel}>
                  Street address
                </InputLabel>
                {renderInput('Line1')}
              </Grid>

              <Grid item xs={12} sm={4}>
                <InputLabel shrink htmlFor="bootstrap" className={classes.inputLabel}>
                  Suburb
                </InputLabel>
                {renderInput('City')}
              </Grid>

              <Grid item xs={12} sm={4}>
                <InputLabel shrink htmlFor="bootstrap" className={classes.inputLabel}>
                  State
                </InputLabel>
                {renderInput('CountrySubDivisionCode')}
              </Grid>

              <Grid item xs={12} sm={6}>
                <InputLabel shrink htmlFor="bootstrap" className={classes.inputLabel}>
                  Postcode
                </InputLabel>
                {renderInput('PostalCode')}
              </Grid>

              <Grid item xs={12} sm={6}>
                <InputLabel shrink htmlFor="bootstrap" className={classes.inputLabel}>
                  Country
                </InputLabel>
                {renderInput('Country')}
              </Grid>
            </Grid>
          </Paper>
        </Grid>

        {/* type and approval request container  */}
        <Grid item xs={12}>
          <Paper className={classes.paper}>
            <Grid item xs={12} className={classes.iconHeader}>
              <VerifiedUserIcon style={{ marginRight: '4px' }} />
              <Typography fontSize={16}>Administration</Typography>
            </Grid>

            <Grid item container xs={12} mt={'0px'} spacing={2} pl={isSmall ? 0 : 3}>
              {/* user type */}
              <Grid item xs={12} sm={4}>
                <Typography htmlFor="bootstrap" style={{ marginBottom: '0.5rem', color: '#393A3D', fontSize: '14px' }}>
                  User Type
                </Typography>

                <ReactSelect
                  maxMenuHeight={250}
                  classNamePrefix="select"
                  value={selectedUserType}
                  isSearchable={true}
                  name="approverList"
                  options={userTypeOptions}
                  onChange={handleSelectedUserType}
                />
                {errors?.userRole && <FormHelperText error>{errors.userRole.message}</FormHelperText>}
              </Grid>

              {/* approval required */}
              <Grid item xs={12} sm={8} style={{ display: 'flex', flexDirection: 'column' }}>
                <Typography fontSize={14}>Approval</Typography>

                <div className={classes.inlineControl}>
                  <Checkbox
                    checked={approvalRequired}
                    onChange={handleApprovalRequired}
                    color="primary"
                    inputProps={{ 'aria-label': 'secondary checkbox' }}
                  />
                  <Typography component="span" style={{ marginBottom: '0.5rem', color: '#393A3D', fontSize: '15px' }}>
                    Requires Approval?
                  </Typography>
                </div>

                {approvalRequired && (
                  <div style={{ marginBottom: '2rem' }}>
                    <Typography style={{ color: 'rgb(107, 108, 114)', fontSize: '14px' }}>Select Approval</Typography>
                    <ReactSelect
                      maxMenuHeight={250}
                      classNamePrefix="select"
                      value={selectedApprover}
                      isSearchable={true}
                      name="approverList"
                      options={userListOptions}
                      onChange={handleSelectedApprover}
                      styles={{
                        menuList: (base) => ({
                          ...base,
                          height: '165px',
                          '::-webkit-scrollbar': {
                            width: '9px'
                          },
                          '::-webkit-scrollbar-thumb': {
                            background: '#888'
                          },
                          '::-webkit-scrollbar-thumb:hover': {
                            background: '#555'
                          }
                        })
                      }}
                    />
                    {errors?.approverId && <FormHelperText error>{errors.approverId.message}</FormHelperText>}
                  </div>
                )}
              </Grid>

              {/* portal access */}
              <Grid item xs={12}>
                <div
                  className={`${classes.portalAccessPanel} ${
                    !hasExistingUser ? classes.portalAccessPanelDisabled : ''
                  }`}
                >
                  <Typography htmlFor="bootstrap" style={{ color: '#393A3D', fontSize: '14px' }}>
                    Portal Access
                  </Typography>
                  <div className={classes.inlineControl}>
                    <Switch
                      checked={portalAccessChecked}
                      onChange={handlePortalAccessDialog}
                      color="primary"
                      name="portalAccess"
                      disabled={!hasExistingUser || portalAccessSubmitting}
                      inputProps={{ 'aria-label': 'primary checkbox' }}
                    />
                    {portalAccessSubmitting && <CircularProgress size={18} />}
                    <Typography component="span" style={{ color: '#393A3D', fontSize: '14px' }}>
                      {portalAccessChecked ? 'Enabled' : 'Disabled'}
                    </Typography>
                  </div>
                  {!hasExistingUser && (
                    <Typography style={{ color: '#777', fontSize: '13px' }}>
                      Save this user before giving portal access.
                    </Typography>
                  )}
                </div>
                {portalAccessDialog && (
                  <UserPortalAccessDialog
                    open={portalAccessDialog}
                    portalAccess={portalAccessChecked}
                    handleClose={handlePortalAccessDialogClose}
                    sendLoginDetailsToUser={sendLoginDetailsToUser}
                    removeLoginDetailsOfUser={removeLoginDetailsOfUser}
                    employeeId={row.id}
                    submitting={portalAccessSubmitting}
                  />
                )}
              </Grid>
            </Grid>
          </Paper>
        </Grid>
        {/* type and approval request container complete */}

        {/* user's office info */}
        <Grid item xs={12}>
          <Paper className={classes.paper}>
            <Grid item xs={12} className={classes.iconHeader}>
              <BusinessIcon style={{ marginRight: '4px' }} />
              <Typography fontSize={16}>Office Info</Typography>
            </Grid>
            <Grid item container xs={12} mt={'12px'} spacing={2} pl={isSmall ? 0 : 3}>
              <UserOfficeInfo employeeId={row.id} />
            </Grid>
          </Paper>
        </Grid>

        {/* user's leave balances, annual leave, Rdo, Personal leave */}
        <Grid item xs={12} style={{ marginBottom: '2rem' }}>
          <Paper className={classes.paper}>
            <Grid item xs={12} className={classes.iconHeader}>
              <FlightTakeoffIcon style={{ marginRight: '4px' }} />
              <Typography fontSize={16}>Leave Balances</Typography>
            </Grid>

            <Grid item container xs={12} mt={'0px'} spacing={2} pl={isSmall ? 0 : 3}>
              <Grid item xs={12} sm={4}>
                <InputLabel shrink htmlFor="bootstrap" className={classes.inputLabel}>
                  Annual Leave
                </InputLabel>
                <BootstrapInput
                  name="annualLeave"
                  value={annualLeave || ''}
                  onChange={onChange}
                  id="bootstrap"
                  className={classes.bootstrapInput}
                  disabled
                />
              </Grid>

              <Grid item xs={12} sm={4}>
                <InputLabel shrink htmlFor="bootstrap" className={classes.inputLabel}>
                  RDO
                </InputLabel>
                <BootstrapInput
                  name="rdo"
                  value={rdo || ''}
                  onChange={onChange}
                  id="bootstrap"
                  className={classes.bootstrapInput}
                  disabled
                />
              </Grid>

              <Grid item xs={12} sm={4}>
                <InputLabel shrink htmlFor="bootstrap" className={classes.inputLabel}>
                  Personal Leave
                </InputLabel>
                <BootstrapInput
                  name="personalLeave"
                  value={personalLeave || ''}
                  onChange={onChange}
                  id="bootstrap"
                  className={classes.bootstrapInput}
                  disabled
                />
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </Grid>
    </div>
  );
};

export default UserGeneralDialogContent;

UserGeneralDialogContent.propTypes = {
  row: PropTypes.any,
  onChange: PropTypes.func,
  vendorRecords: PropTypes.array,
  keyPayEmployeeRecords: PropTypes.array,
  selectedEmployeeToRegister: PropTypes.any,
  setSelectedEmployeeToRegister: PropTypes.func,
  rows: PropTypes.array,
  selectedUserType: PropTypes.shape({ value: PropTypes.string, label: PropTypes.string }),
  setSelectedUserType: PropTypes.func,
  approvalRequired: PropTypes.bool,
  setApprovalRequired: PropTypes.func,
  selectedApprover: PropTypes.any,
  setSelectedApprover: PropTypes.func,
  open: PropTypes.bool,
  portalAccess: PropTypes.bool,
  setPortalAccess: PropTypes.func,
  portalAccessDialog: PropTypes.bool,
  setPortalAccessDialog: PropTypes.func,
  setRows: PropTypes.func,
  control: PropTypes.any,
  errors: PropTypes.object,
  setFormValue: PropTypes.func,
  outlookEmailStatus: PropTypes.oneOf(['idle', 'checking', 'valid', 'invalid', 'error'])
};
